export default {
  meta: {
    title: '个人招商报表',
    url: '/expandstore/individualperformance'
  }
};
